import React, { useEffect } from "react";
import Textfield from "@atlaskit/textfield";
import { useSelector, useDispatch } from "react-redux";
import { setCurrentWizardData } from "../../../../redux/actions/wizardActions";

const WizardBasicAuth = () => {
  const currentData = useSelector((state) => state.wizard.currentData);
  const dispatch = useDispatch();

  const onChange = (fieldName) => (e) => {
    const updatedData = {
      ...currentData,
      [fieldName]: e.target.value,
    };
    dispatch(setCurrentWizardData(updatedData));
  };

  return (
    <div>
      Jira User Email:
      <Textfield
        name="username"
        value={currentData?.jiraUserEmail ? currentData?.jiraUserEmail : ""}
        onChange={onChange("jiraUserEmail")}
      />
      <p>Enter the email address of the user that will be used to access the Jira API.</p>
      Jira User PAT token:
      <Textfield
        name="password"
        value={currentData?.jiraUserPassword ? currentData?.jiraUserPassword : ""}
        onChange={onChange("jiraUserPassword")}
        type="password"
      />
      <p>Enter the <a href="https://support.atlassian.com/atlassian-account/docs/manage-api-tokens-for-your-atlassian-account/" target="_blank">PAT token</a> for the user that will be used to access the Jira API.</p>
    </div>
  );
};

export default WizardBasicAuth;
